import axios from "axios";

import deploymentUrls from "../envs/deploymentConfigs";
import * as msal from '@azure/msal-browser'; 
import msalInstance from "../auth/msalInstance";
import { apiScopeConfig, loginRequest } from "../auth/authConfig";
import { LAST_SELECTED_COUNTRY_HEADER } from "../../utils/constants";
import { getLastSelectedCountryID } from "../../utils/lastSelectedCountryStore";

// Define the base API URL
const baseApiUrl = deploymentUrls.api;

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: baseApiUrl,
});

// Interceptor to add the Authorization header with the token
axiosInstance.interceptors.request.use(async (config) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    return config;
  }
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: apiScopeConfig.apiScope,
      account: accounts[0],
    });
    if (tokenResponse?.accessToken) {
      config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
    }
  } catch (error) {
    if (error instanceof msal.InteractionRequiredAuthError) {
      // Avoid popup in SPAs with redirect flow; let the app's login flow handle it
      // Optionally kick off a background redirect to refresh tokens
      try {
        await msalInstance.acquireTokenRedirect({
          scopes: apiScopeConfig.apiScope,
          account: accounts[0]
        });
      } catch (_) {}
    }
  }

  const countryID = getLastSelectedCountryID();
  if (countryID) {
    config.headers = config.headers ?? {};
    config.headers[LAST_SELECTED_COUNTRY_HEADER] = countryID;
  }

  return config;
});

// Optional: Handle 401 Unauthorized responses
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Let callers handle 401; avoid leaking internal route
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
